// Toast notification plugin
import { createApp } from "vue";
import ToastNotification from "@/components/ToastNotification.vue";

export default {
  install(app) {
    // Create a container for the toast component
    const toastContainer = document.createElement("div");
    document.body.appendChild(toastContainer);

    // Create and mount the toast component
    const toastApp = createApp(ToastNotification);
    const toastInstance = toastApp.mount(toastContainer);

    // Add global methods
    app.config.globalProperties.$toast = {
      success(message, duration = 3000) {
        toastInstance.show(message, "success", duration);
      },
      error(message, duration = 3000) {
        toastInstance.show(message, "error", duration);
      },
      warning(message, duration = 3000) {
        toastInstance.show(message, "warning", duration);
      },
      info(message, duration = 3000) {
        toastInstance.show(message, "info", duration);
      },
    };

    // Also provide as a global property for composition API
    app.provide("toast", app.config.globalProperties.$toast);
  },
};
